import React, { useState, useEffect } from "react";
import ReportWidget from "../components/ReportWidget/ReportWidget";
import BarComponent from "../components/BarComponent/BarComponent";
import { promptByCompany } from "../api/accel/chat";
import { Typography, Grid, Box, CircularProgress } from "@mui/material";
import AiReportsComponent from "../components/AiReportsComponent/AIReportsComponent";
import { downloadReportAsPDF } from "../utils/reportUtils";
import { useAccelContext } from "../contexts/AccelContext/AccelContext";
import { Accel } from "../api/accel";
import IncomeStatementWidget from "../components/IncomeStatementWidget/IncomeStatementWidget";
import useSWR from "swr";
type ReportType = "profit_loss" | "balance_sheet" | "cash_flow" | "ai_reports";

export const ReportView = () => {
  const [reportType, setReportType] = useState<ReportType>("profit_loss");
  const {
    theme,
    auth,
    apiUrl,
    companyId,
    incomeStatementSheet,
    authErrorState,
  } = useAccelContext();

  if (authErrorState) {
    return null; // or return <></> for an empty fragment
  }

  const values = [{ value: "profit_loss", label: "Profit & Loss" }];

  const reportData: Record<
    ReportType,
    { title: string; value: string; sections: any[] }
  > = {
    profit_loss: { title: "Profit & Loss", value: "N/A", sections: [] },
    balance_sheet: { title: "Balance Sheet", value: "N/A", sections: [] },
    cash_flow: { title: "Cash Flow", value: "N/A", sections: [] },
    ai_reports: { title: "AI Reports", value: "N/A", sections: [] },
  };

  const downloadPDF = async () => {
    if (reportType === "profit_loss" && auth.access_token) {
      try {
        
        // Open the PDF URL in a new tab
        if (incomeStatementSheet?.pdf_url) {
          window.open(
            incomeStatementSheet.pdf_url,
            "_blank",
            "noopener,noreferrer"
          );
        } else {
          console.error("PDF URL is undefined");
        }
      } catch (error) {
        console.error("Error opening PDF:", error);
      }
    }
  };

  return (
    <Grid container spacing={3}>
      <Grid
        item
        container
        sx={{
          alignItems: "center",
          justifyContent: "space-between",
          flexDirection: "row",
        }}
        width="100%"
        spacing={2}
      >
        <Box sx={{ py: 1 }}>
          <Typography
            variant="h5"
            component="div"
            sx={{
              color: theme?.text?.hex,
              fontSize: 41,
              fontFamily: "Helvetica Neue",
            }}
          >
            Reports
          </Typography>
        </Box>
      </Grid>

      <Grid item width="100%">
        <BarComponent
          values={values}
          toggleType={reportType}
          setToggleType={(type: string) => setReportType(type as ReportType)}
          showToggleGroup={true}
          showButtons={true}
          showDownloadButton={true}
          showDatePicker={true}
          onDownload={downloadPDF}
          showSearchBar={false}
        ></BarComponent>
      </Grid>
      <Grid item width="100%">
        <Box
          sx={{
            minHeight: "700px",
            width: "100%",
            alignItems: "start",
          }}
        >
          {reportType === "ai_reports" ? (
            <AiReportsComponent />
          ) : incomeStatementSheet === null ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <IncomeStatementWidget
              title={
                incomeStatementSheet?.formattedIncomeStatement.title || "N/A"
              }
              netIncome={
                incomeStatementSheet?.formattedIncomeStatement.netIncome ||
                "N/A"
              }
              sections={
                incomeStatementSheet?.formattedIncomeStatement.sections || []
              }
            />
          )}
        </Box>
      </Grid>
    </Grid>
  );
};

export default ReportView;
